import { API } from '@/store/api';
import type { IPresident } from '@/types';
import { useMemo } from 'react';

export const useAllPresidents = (locale: string) => {
    const { data: page1Data, isLoading: isLoading1, error: error1 } = API.historyApi.useGetHistoryQuery(
        { locale, page: 1 },
        { skip: !locale }
    );

    const { data: page2Data, isLoading: isLoading2, error: error2 } = API.historyApi.useGetHistoryQuery(
        { locale, page: 2 },
        { skip: !locale }
    );

    const { data: page3Data, isLoading: isLoading3, error: error3 } = API.historyApi.useGetHistoryQuery(
        { locale, page: 3 },
        { skip: !locale }
    );

    const allPresidents: IPresident[] = useMemo(() => {
        const presidents: IPresident[] = [];

        if (page1Data?.presidents) {
            presidents.push(...page1Data.presidents);
        }
        if (page2Data?.presidents) {
            presidents.push(...page2Data.presidents);
        }
        if (page3Data?.presidents) {
            presidents.push(...page3Data.presidents);
        }

        return presidents.sort((a, b) => {
            if (a.is_current && !b.is_current) return -1;
            if (!a.is_current && b.is_current) return 1;

            const dateA = new Date(a.start_date || 0);
            const dateB = new Date(b.start_date || 0);
            return dateB.getTime() - dateA.getTime();
        });
    }, [page1Data?.presidents, page2Data?.presidents, page3Data?.presidents]);

    const isLoading = isLoading1 || isLoading2 || isLoading3;

    const error = error1 || error2 || error3;

    const historyPage = page1Data?.history_page;

    return {
        presidents: allPresidents,
        historyPage,
        isLoading,
        error,
        totalPresidents: page1Data?.pagination?.total || 0,
    };
};